import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './quick-action.module.css';

const QuickAction: FC<{
  title: string;
  buttons: QuickActionButton[];
}> = ({ title, buttons }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.quickActionContainer}>
      <p className={styles.quickActionTitle}>{title}</p>
      <div className={styles.quickActionButtons}>
        {buttons.map((button, index) => (
          <div className={styles.quickActionButton} key={index}>
            <div
              className={styles.quickActionButtonImage}
              onClick={() => navigate(button.path)}
            >
              <img src={button.icon} alt={button.label} title={button.label} />
            </div>
            <p onClick={() => navigate(button.path)}>{button.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickAction;
